module.exports = __webpack_public_path__ + "img/blue_023.c1d370f1.png";